import React, { useState, useEffect } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import { useDebouncedCallback } from "use-debounce";
import { Input } from "@/components/ui/input";
import { Notification } from "@/components/ui/notification";
import { ExternalLink } from "ui/Link";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import { useRegisterFlush } from "../platform-fields/flush-registry";

const YouTubeTitle = ({
  url,
  post,
  field,
  checkSetting = false,
  selectedPlatform,
  selectedAccounts,
  platforms,
  title,
  className = "",
  onChange,
  disabled = false,
  errors,
}) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (post["ytTitle"]) {
      setValue(post["ytTitle"]);
    }
  }, []);

  const bounce = useDebouncedCallback((value) => {
    let title = post["ytTitle"];
    if (value != title) {
      onChange(value);
    }
  }, 200);
  useRegisterFlush(bounce.flush);

  return (
    <div className={className}>
      <div className="flex flex-col mb-4">
        <div className="flex items-center mb-2">
          <PostFieldLabel className="mr-2">{title}</PostFieldLabel>
          <PlatformUsage
            platforms={platforms}
            field={FIELDS.YT_TITLE}
            selectedPlatform={selectedPlatform}
          />
        </div>
        <Notification
          variant="info"
          expandable
          title="Post a YouTube #short?"
          className="mb-2"
          description={
            <>
              If your video meets{" "}
              <ExternalLink
                href={`https://help.skedsocial.com/en/articles/6497825-post-youtube-shorts-with-sked`}
              >
                the requirements
              </ExternalLink>
              , add #shorts to your video title or caption to post this video as
              a YouTube short.{" "}
              <ExternalLink
                href={`https://help.skedsocial.com/en/articles/6497825-post-youtube-shorts-with-sked`}
              >
                Read more
              </ExternalLink>
              .
            </>
          }
        />
        <Input
          value={value}
          disabled={disabled}
          placeholder="The title of your video (required)"
          aria-invalid={value.length > 100 || undefined}
          className="h-8 !border-neutral-100 px-3.5 py-1.5 font-normal aria-invalid:!border-red-500 aria-invalid:!shadow-[0_0_0_2px_rgba(239,68,68,0.08),0_1px_2px_rgba(16,24,40,0.05)]"
          onChange={(event) => {
            const newVal = event.target.value;
            setValue(newVal);
            bounce(newVal);
          }}
        />
        {value.length <= 100 && (
          <PostFieldError
            fields={[FIELDS.YT_TITLE]}
            errors={errors}
            className="mb-[-10px]"
          />
        )}
        {value.length > 100 && (
          <p className="mt-1 font-inter text-sm font-normal leading-5 text-red-500">
            Video title must be 100 characters or fewer.
          </p>
        )}
      </div>
    </div>
  );
};

export default YouTubeTitle;
